import { useMediaQuery } from "@mui/material";
import { useMemo } from "react";

interface useMobileViewProps {}

export const useMobileView = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const isMobileView = useMediaQuery("(max-width: 715px");
    /* ******************** Functions ******************** */
    const flexDirection: "column" | "row" = useMemo(()=>{
        return isMobileView ? "column" : "row"
    }, [isMobileView])
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        isMobileView,
        flexDirection
    }
}